import React from "react";
import { classNames } from "./classNames";

export const FlatLayer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, style, children, ...rest }, ref) => (
  <div
    ref={ref}
    className={classNames(
      "absolute inset-0 grid place-items-center pointer-events-none z-[1000]",
      className
    )}
    style={{ transform: "none", ...style }}
    {...rest}
  >
    {children}
  </div>
));

FlatLayer.displayName = "FlatLayer";
